// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GoogleSignIn_Wrapper__1Qxw3","GoogleLogin":"GoogleSignIn_GoogleLogin__3Y0L3"};